import { PlatformService } from '@application/platform.service';
import { UniversalConfig } from '@application/universal_config.service';
import { useResolve } from '@visiba/instantiation';
import { useConstant } from '@visiba/react-std';
import { hasEndToEndEncryptionSupport } from './has_end_to_end_encryption_support.module';

export function useVonageEncryptionWarning() {
	const universalConfig = useResolve(UniversalConfig);
	const platformService = useResolve(PlatformService);
	const appConfig = universalConfig.appConfig;
	const platform = platformService.parseAgentData().platform;
	const appDownloadUrl = useConstant(() => {
		if (appConfig && platform.android) {
			return `https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=${appConfig.androidPackageId}`;
		}
		if (appConfig && platform.ios) {
			return `https://apps.apple.com/se/app/id${appConfig.appStoreId}`;
		}

		return null;
	});

	return {
		platform: platformService.parseAgentData().platform,
		appConfig: appConfig
			? {
					androidPackageId: appConfig.androidPackageId,
					appStoreId: appConfig.appStoreId,
					appDownloadUrl: appDownloadUrl,
				}
			: null,
		hasEncryptionSupport: hasEndToEndEncryptionSupport(),
	};
}
